// Shared parse + device filter for the game_images JSON string built by the backend.
// Images without device_target (legacy JSON) count as 'all'. If filtering would
// leave nothing, the full set is returned so a game never shows an empty carousel.
export const MOBILE_BREAKPOINT = 576

export function parseGameImages(rawGameImages, isMobile) {
  let images = []
  try {
    images = JSON.parse(rawGameImages) || []
  } catch (e) {
    return []
  }
  if (!Array.isArray(images) || images.length === 0) return []
  const excluded = isMobile ? 'desktop' : 'mobile'
  const filtered = images.filter(img => (img.device_target || 'all') !== excluded)
  return filtered.length > 0 ? filtered : images
}
